(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  (() => {
    if (window.ppBlogAjaxNavigationInitialized) return;
    window.ppBlogAjaxNavigationInitialized = true;

    if (window.Shopify && Shopify.designMode) return;

    const blogSelector = '.pp-blog';
    const navigationSelector =
      '.pp-blog-topic[href], .pp-blog-results__heading a[href], .pagination-wrapper a[href]';
    const headSelectors = [
      'link[rel="canonical"]',
      'meta[name="description"]',
      'meta[name="robots"]',
      'meta[property="og:title"]',
      'meta[property="og:description"]',
      'meta[property="og:url"]',
      'meta[name="twitter:title"]',
      'meta[name="twitter:description"]',
    ];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const pageCache = new Map();
    let activeController = null;
    let navigationSequence = 0;

    const normalizePath = (path) => path.replace(/\/$/, '') || '/';

    const destinationFor = (link, event) => {
      if (
        !link ||
        !link.closest(blogSelector) ||
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey ||
        link.hasAttribute('download') ||
        (link.target && link.target !== '_self')
      ) {
        return null;
      }

      const destination = new URL(link.href, window.location.href);
      if (destination.origin !== window.location.origin || destination.href === window.location.href) return null;

      const allGuidesLink = link.closest(blogSelector)?.querySelector('.pp-blog-topic[href]');
      if (!allGuidesLink) return null;

      const blogPath = normalizePath(new URL(allGuidesLink.href, window.location.href).pathname);
      const destinationPath = normalizePath(destination.pathname);
      if (destinationPath !== blogPath && !destinationPath.startsWith(`${blogPath}/tagged/`)) return null;

      return destination;
    };

    const fetchPage = async (destination, signal) => {
      let markup = pageCache.get(destination.href);

      if (!markup) {
        const response = await fetch(destination.href, {
          credentials: 'same-origin',
          headers: {
            Accept: 'text/html',
            'X-Requested-With': 'XMLHttpRequest',
          },
          signal,
        });

        if (!response.ok) throw new Error(`Blog navigation failed with ${response.status}`);
        markup = await response.text();
        pageCache.set(destination.href, markup);
      }

      const parsedDocument = new DOMParser().parseFromString(markup, 'text/html');
      const incomingBlog = parsedDocument.querySelector(blogSelector);
      if (!incomingBlog) throw new Error('Blog navigation response did not contain the blog section');

      return { incomingBlog, parsedDocument };
    };

    const syncHead = (parsedDocument) => {
      document.title = parsedDocument.title;

      headSelectors.forEach((selector) => {
        const incoming = parsedDocument.head.querySelector(selector);
        const current = document.head.querySelector(selector);

        if (incoming) {
          const replacement = incoming.cloneNode(true);
          if (current) current.replaceWith(replacement);
          else document.head.append(replacement);
        } else if (current) {
          current.remove();
        }
      });
    };

    const initializeIncomingBlog = (incomingBlog, focusSelector) => {
      incomingBlog.removeAttribute('aria-busy');
      incomingBlog.classList.remove('is-leaving');

      if (typeof window.initializeScrollAnimationTrigger === 'function') {
        window.initializeScrollAnimationTrigger(incomingBlog);
      }

      if (focusSelector) {
        window.requestAnimationFrame(() => {
          const focusTarget = incomingBlog.querySelector(focusSelector);
          if (focusTarget instanceof HTMLElement) {
            if (!focusTarget.matches('a[href], button, input, select, textarea, [tabindex]')) {
              focusTarget.setAttribute('tabindex', '-1');
            }
            focusTarget.focus({ preventScroll: true });
          }
        });
      }
    };

    const swapPage = async (destination, parsedDocument, incomingBlog, historyMode, focusSelector) => {
      const currentBlog = document.querySelector(blogSelector);
      if (!currentBlog) throw new Error('Current blog section is unavailable');

      let nextBlog = incomingBlog;
      const commit = () => {
        nextBlog = incomingBlog.cloneNode(true);
        initializeIncomingBlog(nextBlog, focusSelector);
        currentBlog.replaceWith(nextBlog);
        syncHead(parsedDocument);

        if (historyMode === 'push') {
          history.pushState({ ...(history.state || {}), ppBlogUrl: destination.href }, '', destination.href);
        }
      };

      if (typeof document.startViewTransition === 'function' && !reducedMotion.matches) {
        const transition = document.startViewTransition(commit);
        await transition.updateCallbackDone;
        transition.finished.catch(() => {});
        return nextBlog;
      }

      if (!reducedMotion.matches && typeof currentBlog.animate === 'function') {
        const exitAnimation = currentBlog.animate(
          [
            { opacity: 1, transform: 'translateY(0)' },
            { opacity: 0, transform: 'translateY(6px)' },
          ],
          { duration: 120, easing: 'ease', fill: 'forwards' }
        );
        await exitAnimation.finished.catch(() => {});
      }

      commit();

      if (!reducedMotion.matches && typeof nextBlog.animate === 'function') {
        nextBlog.animate(
          [
            { opacity: 0, transform: 'translateY(6px)' },
            { opacity: 1, transform: 'translateY(0)' },
          ],
          { duration: 220, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' }
        );
      }

      return nextBlog;
    };

    const navigate = async (destination, { historyMode = 'push', focusSelector = '' } = {}) => {
      const sequence = ++navigationSequence;
      activeController?.abort();
      activeController = new AbortController();

      const currentBlog = document.querySelector(blogSelector);
      currentBlog?.setAttribute('aria-busy', 'true');

      try {
        const { incomingBlog, parsedDocument } = await fetchPage(destination, activeController.signal);
        if (sequence !== navigationSequence) return;

        await swapPage(destination, parsedDocument, incomingBlog, historyMode, focusSelector);
        if (sequence !== navigationSequence) return;

        window.dispatchEvent(
          new CustomEvent('pp:blog:navigated', {
            detail: { title: document.title, url: destination.href },
          })
        );
      } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') return;

        document.querySelector(blogSelector)?.removeAttribute('aria-busy');
        if (historyMode === 'push') window.location.assign(destination.href);
        else window.location.reload();
      } finally {
        if (sequence === navigationSequence) activeController = null;
      }
    };

    document.addEventListener('click', (event) => {
      const link = event.target.closest(navigationSelector);
      const destination = destinationFor(link, event);
      if (!destination) return;

      event.preventDefault();
      const focusSelector = link.matches('.pagination-wrapper a[href]')
        ? '.pp-blog-results__heading h2'
        : '.pp-blog-topic.is-active';
      navigate(destination, { focusSelector });
    });

    window.addEventListener('popstate', () => {
      if (!document.querySelector(blogSelector)) return;
      navigate(new URL(window.location.href), { historyMode: 'none' });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
